import React from "react"
import { usePosts } from "../../../hooks/usePosts"
import Container from "../../atoms/Container"
import "./Blogs.css"
import BlogCard from "../../atoms/Cards/BlogCard"

export default function Blogs({ block }) {
  const data = usePosts()

  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-blog-container">
        <h2>{block.titel}</h2>
        <div className="vt-blog-container-slider">
          {data.allWpPost.edges.map(posts => {
            return <BlogCard data={posts.node} />
          })}
        </div>
      </div>
      <div className="vt-whitespace-container"></div>
    </Container>
  )
}
